import React from "react";

function Sites() {
  return (
    <section className="section section--services section--wave-bg --section-mlarge-tb-padding">
      <div className="container">
        <div className="container__row --flex-center --section-small-tb-padding">
          <div className="container__col-md-4 container__col-xs-12">
            <h2 className="container__heading">
              Our Salesforce Sites and Communities services:
            </h2>
            <div className="container__services">
              <div className="container__row">
                <div className="container__col-md-2 container__col-xs-2">
                  <img src="../../solutions/checkmark.png" alt="Hashout" />
                </div>
                <div className="container__col-md-10 container__col-xs-10">
                  <h5 className="container__sub-heading">
                    Componentized UX Design support
                  </h5>
                </div>
              </div>
              <div className="container__row">
                <div className="container__col-md-2  container__col-xs-2">
                  <img src="../../solutions/checkmark.png" alt="Hashout" />
                </div>
                <div className="container__col-md-10  container__col-xs-10">
                  <h5 className="container__sub-heading">
                    Lightning and LWC migration and Design
                  </h5>
                </div>
              </div>
              <div className="container__row">
                <div className="container__col-md-2  container__col-xs-2">
                  <img src="../../solutions/checkmark.png" alt="Hashout" />
                </div>
                <div className="container__col-md-10  container__col-xs-10">
                  <h5 className="container__sub-heading">
                    End-to-end support for new site and communities launch
                  </h5>
                </div>
              </div>
              <div className="container__row">
                <div className="container__col-md-2  container__col-xs-2">
                  <img src="../../solutions/checkmark.png" alt="Hashout" />
                </div>
                <div className="container__col-md-10  container__col-xs-10">
                  <h5 className="container__sub-heading">
                    Enhancements to existing experiences
                  </h5>
                </div>
              </div>
              <div className="container__row">
                <div className="container__col-md-2  container__col-xs-2">
                  <img src="../../solutions/checkmark.png" alt="Hashout" />
                </div>
                <div className="container__col-md-10  container__col-xs-10">
                  <h5 className="container__sub-heading">
                    Integrations to 3rd Party systems
                  </h5>
                </div>
              </div>
              <div className="container__row">
                <div className="container__col-md-2  container__col-xs-2">
                  <img src="../../solutions/checkmark.png" alt="Hashout" />
                </div>
                <div className="container__col-md-10  container__col-xs-10">
                  <h5 className="container__sub-heading">SSO</h5>
                </div>
              </div>
              <div className="container__row">
                <div className="container__col-md-2  container__col-xs-2">
                  <img src="../../solutions/checkmark.png" alt="Hashout" />
                </div>
                <div className="container__col-md-10  container__col-xs-10">
                  <h5 className="container__sub-heading">
                    Custom analytics implementations
                  </h5>
                </div>
              </div>
              <div className="container__row">
                <div className="container__col-md-2  container__col-xs-2">
                  <img src="../../solutions/checkmark.png" alt="Hashout" />
                </div>
                <div className="container__col-md-10  container__col-xs-10">
                  <h5 className="container__sub-heading">
                    Functional assessment of site performance
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="container__col-md-7 container__col-md-offset-1 container__col-xs-12 --flex-center">
            <img
              className="container__img --bg-absolute-right"
              src="../../solutions/platforms/salesforce-services.png"
              alt="salesforce-services"
            />
          </div>
        </div>
      </div>
      {/* <!-- <img className="section__wave" src="../images/wave.svg" alt="Hashout" /> --> */}
    </section>
  );
}

export default Sites;
